module.exports = __webpack_public_path__ + "img/tuto_internet_way_01_03.2b5b0e16.png";